module.exports = [
  {
    identifier: "level-1-ski",
    title: "Ski Instructor Level 1",
    discipline: "Alpine Skiing",
    conditions: {
      score_0: 0.15,
      score_3: 0.6,
    },
  },
  {
    identifier: "level-1-snowboard",
    title: "Snowboard Instructor Level 1",
    discipline: "Snowboarding",
    conditions: {
      score_0: 0.1,
      score_3: 0.7,
    },
  },
];
